import axios from "axios";
import { api } from "./api";

const TOKEN_KEY = "admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const adminApi = axios.create({
  baseURL: api.defaults.baseURL,
});

adminApi.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

// Returns a flag — caller routes accordingly. Does not redirect.
export const verifyToken = async () => {
  const t = getToken();
  if (!t) return false;
  try {
    await adminApi.get("/admin/verify");
    return true;
  } catch {
    clearToken();
    return false;
  }
};
